import { useState } from "react";
import ProfileUser from "sushiweb/Icons/all/ProfileUser";
import {
  DesktopWrapper,
  LogoBlock,
  VerticalDivider,
  OutletInfo,
  OutletName,
  OutletAddressRow,
  ChangeOutletLink,
  ProfileButton,
} from "./styles.header";
import OutletSwitchSheet from "./OutletSwitchSheet";

const HeaderDesktop = ({ showProfile, handleProfile, showSubHeader, sellerDetail, allSellerDetails }) => {
  const [showOutletSheet, setShowOutletSheet] = useState(false);

  return (
    <DesktopWrapper>
      <LogoBlock>
        <img src="/logos/hp_seller_logo.svg" height="42px" width="113px" />
      </LogoBlock>
      {showSubHeader && (
        <>
          <VerticalDivider />
          <OutletInfo>
            <OutletName>{sellerDetail?.outlet_name}</OutletName>
            <OutletAddressRow>
              <span>{sellerDetail?.address}</span>
              <ChangeOutletLink onClick={() => setShowOutletSheet(true)}>
                Change outlet
                <img src={"/logos/chevron-down-large.svg"} alt="" />
              </ChangeOutletLink>
            </OutletAddressRow>
          </OutletInfo>
        </>
      )}
      {showProfile && (
        <ProfileButton onClick={handleProfile}>
          <ProfileUser size={24} />
        </ProfileButton>
      )}
      <OutletSwitchSheet
        visible={showOutletSheet}
        onClose={() => setShowOutletSheet(false)}
        allSellerDetails={allSellerDetails}
      />
    </DesktopWrapper>
  );
};

export default HeaderDesktop;
